// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"842":"38c588eb","853":"298a2386","944":"6c69dc42"}[chunkId] + ".chunk.css";
};